export const STABLE_DELIVERY = 1;
export const ACCELERATED_DELIVERY = 2;
